import { useEffect } from 'react';

import { captureCustomException } from 'App/Services/ErrorTracking/captureCustomException';
import OneSignal from 'react-onesignal';

import { ONESIGNAL_UPDATE_CONSENT_ERROR } from './constants';

/**
 * Syncs functional cookie consent into the OneSignal SDK after init.
 *
 * @param {Object} params
 * @param {boolean} params.pushServiceReady
 * @param {boolean} [params.functionalConsent]
 * @param {boolean} [params.enabled=true] - Skip when the LP does not use privacy consent.
 */
export const useOneSignalConsent = ({
    pushServiceReady,
    functionalConsent,
    enabled = true,
}) => {
    useEffect(() => {
        if (!pushServiceReady || !enabled) return;

        OneSignal.setConsentGiven(Boolean(functionalConsent)).catch((error) => {
            captureCustomException(error, ONESIGNAL_UPDATE_CONSENT_ERROR);
        });
    }, [pushServiceReady, functionalConsent, enabled]);
};
